import { IBusiness } from 'core/model/interfaces/business.interface';
import { IUser } from 'core/model/interfaces/customer.interface';
import { customersData } from './customers.data';
import { addressesDTOtoAddressesData, toCustomersDomain } from './customers.mappers';

export const customersService = {
  getAddresses: async (): Promise<Array<IBusiness>> => {
    const data = await customersData.getAddresses();
    return addressesDTOtoAddressesData(data);
  },

  getProfileUser: async (customerId: number): Promise<IUser> => {
    const data = await customersData.getProfileUser(customerId);
    return toCustomersDomain(data);
  },

  getCreditLimits: (customerId: number) => customersData.getCreditLimits(customerId),
};
